// export const app_url = "https://dedicatedtestserver.com:8101";
export const app_url = "https://services.etijwaal.com";
export const environment =
  "VTJGc2RHVmtYMStQeE9hUG00VUNvRjNFTjJZRWpkTmV1L01qMEpoejlOQT0"; //(Sandbox)
// export const environment = 'VTJGc2RHVmtYMTh1TTYrd0lLZk51NXk4NzVsZDZpeE43cnh1ZUhNRmlCUT0'; //(live)
